"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatTemplatesDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DropdownItem_1 = tslib_1.__importDefault(require("./DropdownItem"));
var DropdownToggleButton_1 = tslib_1.__importDefault(require("./DropdownToggleButton"));
var Overlay_1 = require("../../../Overlay");
var FormatTemplatesDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(FormatTemplatesDropdown, _super);
    function FormatTemplatesDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpened: false,
        };
        _this.closeDropdown = function () {
            _this.setState({ isOpened: false });
        };
        _this.onSelect = function (selectedPreset) {
            _this.props.onChange(selectedPreset.format);
            setTimeout(function () {
                _this.closeDropdown();
            });
        };
        _this.toggleDropdown = function () {
            _this.setState(function (state) { return ({ isOpened: !state.isOpened }); });
        };
        return _this;
    }
    FormatTemplatesDropdown.prototype.render = function () {
        var _this = this;
        var isOpened = this.state.isOpened;
        var _a = this.props, templates = _a.templates, separators = _a.separators;
        return (react_1.default.createElement("div", { className: "gd-measure-format-templates" },
            react_1.default.createElement(DropdownToggleButton_1.default, { toggleDropdown: this.toggleDropdown, isOpened: isOpened }),
            isOpened ? (react_1.default.createElement(Overlay_1.Overlay, { closeOnOutsideClick: true, closeOnParentScroll: true, alignTo: ".gd-measure-custom-format-dialog-section-title", alignPoints: [{ align: "br tr" }, { align: "cr cl", offset: { x: 10 } }], onClose: this.closeDropdown },
                react_1.default.createElement("div", { className: "gd-dropdown overlay" },
                    react_1.default.createElement("div", { className: "gd-measure-number-format-dropdown-body s-measure-number-format-templates-dropdown" }, templates.map(function (template) { return (react_1.default.createElement(DropdownItem_1.default, { key: template.localIdentifier, template: template, onClick: _this.onSelect, separators: separators })); }))))) : null));
    };
    return FormatTemplatesDropdown;
}(react_1.default.Component));
exports.FormatTemplatesDropdown = FormatTemplatesDropdown;
//# sourceMappingURL=FormatTemplatesDropdown.js.map